import React from "react";
import { FiLock } from "react-icons/fi";

import Input from "../../../components/Atoms/Input";
import Loading, {
  SPINNER_ON_GOLD,
} from "../../../components/Atoms/Loading";

import { StyledButton } from "./styles";

interface ResetPasswordProps {
  isRequesting: boolean;
}

const ResetPassword: React.FC<ResetPasswordProps> = ({
  isRequesting = false,
}) => {
  return (
    <>
      <Input
        name="password"
        icon={FiLock}
        type="password"
        placeholder="Digite a nova senha"
        /* Era "on", que nao diz ao navegador QUAL senha. Aqui o campo esta
           definindo uma senha nova, entao o gerenciador deve oferecer geracao
           em vez de sugerir a antiga. */
        autoComplete="new-password"
        customWidth="100%"
        enabled={!isRequesting}
      />

      <StyledButton
        type="submit"
        enabled={!isRequesting}
        aria-label={isRequesting ? "Salvando…" : undefined}
        aria-busy={isRequesting}
      >
        {isRequesting ? (
          <Loading size={2} customColors={SPINNER_ON_GOLD} />
        ) : (
          "Salvar"
        )}
      </StyledButton>
    </>
  );
};

export default ResetPassword;
